import { Box, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowTickLeft from "../../../../../../media/images/icons/arrow-tick-left";
import InprogressTicket from "../../../../../../media/images/icons/inprogressTicketIcon.svg";
import CustomBadge from "../../../../../components/CustomBadge";

import { useAppDispatch } from "../../../../../../hooks/useRedux";
import { setTicketDetail } from "../../../../../../redux/features/userSlice";
import { ITicket } from "../../../../../../types/ticket";
import { convertToJalali } from "../../../../../../utils/functions";

export default function TicketCard({ data }: { data: ITicket }) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const handleTicketDetail = (row: any) => {
    navigate(`/driver/ticket/${row.id}`);
    dispatch(setTicketDetail(row));
  };
  return (
    <Box
      sx={{
        borderRadius: "16px",
        backgroundColor: theme.palette.bgColor.white,
        boxShadow: "0px 2px 8px 0px rgba(0,0,0,0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 8px",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img src={InprogressTicket} alt="" />
        <Typography sx={{ fontWeight: "600", fontSize: "14px" }}>
          {data.title}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <CustomBadge status="inprogress" text="درحال انجام" size="small" />
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "12px",
            }}
          >
            {data.insertDate && convertToJalali(data.insertDate).split(" ")[1]}
          </Typography>
        </Box>

        <Typography
          onClick={() => handleTicketDetail(data)}
          sx={{
            color: "#ffffff",
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            borderRadius: "8px",
            padding: "8px",
            backgroundColor: theme.palette.primary.main,
            mr: "6px",
            cursor: "pointer",
          }}
        >
          مشاهده
        </Typography>
        <ArrowTickLeft size={16} color="#ffffff" />
      </Box>
    </Box>
  );
}
